module.exports = __webpack_public_path__ + "img/step4-en.89a69dab.webp";